import React from "react";
import { ITaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { TaskDynamicFormContainer } from "source/components/task/TaskDynamicFormContainer";
import { IReportItem } from "source/models/report/reportItem";
import { ITaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { TaskDynamicForm } from "source/components/task/TaskDynamicForm/TaskDynamicForm";

interface IReportFilterPanelExtraParametersProps {
    report: IReportItem;
    extraParameters: ITaskDataRow;
    onChange: (extraParameters: ITaskDataRow) => void;
}

export const ReportFilterPanelExtraParameters = (props: IReportFilterPanelExtraParametersProps) => {
    const handleRefreshParameters = (taskDataRowCols: ITaskDataRowCol[]) => {
        if (!props.extraParameters) return;
        const extraParameters = new TaskDataRow(props.extraParameters);
        extraParameters.cols = taskDataRowCols;
        props.onChange(extraParameters);
    };

    if (!props.extraParameters || !props.report) return null;
    return (
        <TaskDynamicFormContainer>
            <TaskDynamicForm
                taskTypeCols={props.report.taskType.formCols}
                taskDataRowCols={props.extraParameters.cols}
                onRefreshCols={handleRefreshParameters}
            />
        </TaskDynamicFormContainer>
    );
};
